exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".hoistAboveOverlay[data-v-db9a1c52]{z-index:2;margin-top:8px}.overlay[data-v-db9a1c52]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1;background-color:#333;opacity:.25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db9a1c52","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/profile/ConsentFormWrapper.vue
// module id = 893
// module chunks = 0